<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div
      class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2"
      [ngClass]="areFiltersSet() ? 'sp-stores__grid-with-filters' : 'sp-stores__grid'">
      <app-stores-header
        (refresh)="onRefresh()"
        (filter)="onFilter()"></app-stores-header>

      <app-stores-summary></app-stores-summary>

      <app-stores-filters
        *ngIf="areFiltersSet()"
        [filters]="filters"
        (filter_clear)="onFilterClear($event)"></app-stores-filters>

      <app-stores-data (refresh)="onRefresh()"></app-stores-data>
    </div>
  </div>
</div>
